/**
 * Tar en email-address och ser om formaten är korrekt med hjälp utav [RegExp]{@link https://www.w3resource.com/javascript/form/email-validation.php}
 * @param email - Sträng med en email-adress
 * @returns Boolean
 */
export const isEmailValid = (email: string) => {
  const regex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  return email.match(regex);
};
